module.exports = __webpack_public_path__ + "static/media/TN-Women-Wallets-2.0.57d531ac.svg";